import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=858729ae&scoped=true&lang=pug"
import script from "./Rights.vue?vue&type=script&lang=js"
export * from "./Rights.vue?vue&type=script&lang=js"
import style0 from "./Rights.vue?vue&type=style&index=0&id=858729ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858729ae",
  null
  
)

export default component.exports